import { readJournalTitle } from "@shared/journal";
import { parsePartialDate } from "@shared/partial_date";
import type { QueueRow } from "../../../../lib/corpusApi";

/**
 * Reads a document's bibliographic details for display — wraps the raw row so the metadata-key
 * and column-fallback rules live here, not in components.
 */
export class DocumentMetadataView {
  constructor(private readonly doc: QueueRow) {}

  get sourceType(): string | null {
    return this.doc.source_type || null;
  }

  get authors(): string | null {
    return this.doc.authors || null;
  }

  get doi(): string | null {
    return this.doc.doi || null;
  }

  get fields(): QueueRow["fields"] {
    return this.doc.fields;
  }

  get journal(): string | null {
    return readJournalTitle(this.doc.metadata);
  }

  /**
   * The publication date at its real precision (`2023-04` stays `2023-04`): the extracted
   * metadata string when it is a valid partial date, else the column, which holds only the first
   * day of the period.
   */
  get publishedDate(): string | null {
    return parsePartialDate(this.doc.metadata?.publication_date)?.value ?? this.doc.published_date;
  }

  get hasAny(): boolean {
    return Boolean(
      this.sourceType ||
      this.authors ||
      this.doi ||
      this.journal ||
      this.publishedDate ||
      this.fields.length
    );
  }
}
